import React from "react";
import { useState, useEffect } from 'react';

// tools and component for date picker
import dayjs from 'dayjs';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getIdSpot, getLivraison, getRidingPeriod, getPanier } from "../../../../store/selectors.js";
import { stockArticlesSlice } from "../../../../store/stockArticlesSlice.js";

//import Fetch API functions
import { getArticles, getOneSpot } from '../../../../database/fetchApi.js'

//created components
import ShoppingGallery from '../../components/shoppinggallery/ShoppingGallery.jsx'
import RecapStep from '../../../../commons/recapstep/RecapStep.jsx'
import HeaderStep from "../../../../commons/headerstep/HeaderStep.jsx";
import InfosPanier from "../../components/infospanier/InfosPanier.jsx";
import InfosRecap1 from "../../components/infosrecap1/InfosRecap1.jsx";

//Utils functions
import { prepareDureeTexte } from '../../../../utils/calcul_duree.js'
import calculDuree from '../../../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)
import { getAllStock } from '../../../../utils/get-stock.js' //async func : params : date1,date2
import { calcPrix, calcPrixDegressif } from "../../../../utils/calcul_prix.js"//parms : tarifs object, duree object
import { fabClasses } from "@mui/material";

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function StepTwo() { // component to manage the first step of shopping : choosing place and time

    const [articles, setArticles] = useState([]);
    const [spotInfos, setSpotInfos] = useState(null); //null is set by default so we can test if promise from axios is fullfilled
    const dispatch = useDispatch();
    const idSpot = useSelector(getIdSpot); //global state : id of the selected spo
    const infosLivraison = useSelector(getLivraison); //global state : id of the selected spo
    const period = useSelector(getRidingPeriod); //global state : id of the selected spo
    let panier = useSelector(getPanier); //get global state : panier
    const dureeObject = calculDuree(period); //get object with quantity for every durations (demis,jour, semaine...)
    const lang = useSelector(getLang) //global state : language

    React.useEffect(() => { //change opening hours when spot change (idspot as dependency)

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initSpot() { //we add this inner function to manage asynchrone
            let infosSpot = await getOneSpot(idSpot);
            setSpotInfos(infosSpot)
        } //end of async function
        initSpot(); //call the inner asnchrone function 

        async function initStock() { //we add this inner function to manage asynchrone
            let allStock = [];
            allStock = await getAllStock(period[0][0], period[0][1]);

            dispatch(stockArticlesSlice.actions.setStockArticles(allStock));
        } //end of async function
        initStock(); //call the inner asnchrone function 


    }, [])



    function prepareInfosPanier() {
        let cumulPanier = { qte: 0, total: 0 }
        let pu = 0;
        if (panier.length > 0) {
            panier.map((item) => {
                cumulPanier.qte += item.qte;
                let currentArticle = articles.filter((article) => article.id_article === item.id_article);
                if (currentArticle.length > 0) { //verify if exist
                    pu = calcPrixDegressif(currentArticle[0].Tarif, dureeObject);
                }
                cumulPanier.total += (pu * item.qte);
            })
        }
        return cumulPanier
    }

    function prepareInfos() {

        let spot = "";
        let dates = "";
        let duree = "";

        // prepare spot infos
        if (idSpot >= 99) {
            spot = "Livraison : " + infosLivraison.secteur + " , " + infosLivraison.adresse; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
        }
        else { // spot is not livraion
            if (spotInfos) { // if promise not fullfilled yet, we block the process to evoid error
                spot = spotInfos.nom_spot + ", " + spotInfos.adresse_spot + " " + spotInfos.ville_spot;
            }
        }

        //prepare dates infos
        dates += "du " + dayjs(period[0][0]).format("DD/MM/YYYY");
        dates += " à " + period[1][0] + "h00";
        dates += " au " + dayjs(period[0][1]).format("DD/MM/YYYY");
        dates += " à " + period[1][1] + "h00";

        //Prepare duree infos
        duree = prepareDureeTexte(dureeObject);

        return { spot, dates, duree }
    }





    return (
        <div className="step2">

            <div className="step2-top">
                <RecapStep step={1} infos={<InfosRecap1 infos={prepareInfos()} />}/* custom={<InfosRecap1 />} */ />

                <HeaderStep step={2} title={translator("Choissez vos vélos", lang, "headerStep2")} custom={<InfosPanier qte={prepareInfosPanier().qte} total={prepareInfosPanier().total} articles={articles} />} />
            </div>

            <div className="step2-shopping-gallery">
                {<ShoppingGallery articles={articles} duree={dureeObject} managerMode={false} />}
            </div>

        </div>

    )
}




export default StepTwo